import React, { useCallback } from "react";

import { format } from "date-fns/esm";
import { FormattedMessage, useIntl } from "react-intl";

import { Popconfirm } from "@mapmycustomers/ui";

import ButtonLink from "@app/component/ButtonLink";
import { getUpcomingMonday } from "@app/util/dates";

import styles from "./OptingCommon.module.scss";

interface Props {
  onToggle?: (enabled: boolean) => void;
}

const OptedIn: React.FC<Props> = ({ onToggle }) => {
  const intl = useIntl();
  const handleClick = useCallback(() => {
    onToggle?.(false);
  }, [onToggle]);

  return (
    <div className={styles.container}>
      <div>
        <p>
          <FormattedMessage
            id="reports.weeklyReportCard.optedIn.Text"
            defaultMessage="You are opted in to receive weekly scorecards! Your next scorecard will be sent on"
            description="Description for opted in weekly reports"
          />
        </p>
      </div>
      <div className={styles.nextReportDate}>
        <p>
          <FormattedMessage
            id="reports.weeklyReportCard.optedInText.nextReportDate"
            defaultMessage="Monday {date}"
            description="Date for next report to be sent out on weekly reports"
            values={{ date: format(getUpcomingMonday(), "MMMM d") }}
          />
          <Popconfirm
            cancelText={intl.formatMessage({
              id: "reports.weeklyReportCard.optOut.popConfirm.cancel",
              defaultMessage: "No",
              description: "No option in opt out for weekly report card",
            })}
            className={styles.optOutPopUp}
            description={intl.formatMessage(
              {
                id: "reports.weeklyReportCard.optOut.confirm.description",
                defaultMessage: "You may still receive other {br}emails from Map My Customers.",
                description: "opt out for weekly report card",
              },
              {
                br: <br />,
              }
            )}
            okText={intl.formatMessage({
              id: "reports.weeklyReportCard.optOut.popConfirm.ok",
              defaultMessage: "Yes, opt out",
              description: "Yes option in opt out for weekly report card",
            })}
            onConfirm={handleClick}
            title={intl.formatMessage(
              {
                id: "reports.weeklyReportCard.optOut.confirm.title",
                defaultMessage: "Are you sure you want to opt {br}out of the Weekly Scorecard?",
                description: "opt out for weekly report card",
              },
              {
                br: <br />,
              }
            )}
          >
            <ButtonLink className={styles.optOutButton}>
              {intl.formatMessage({
                id: "reports.weeklyReportCard.optOutButton",
                defaultMessage: "Opt out?",
                description: "Opt out button on weekly reports",
              })}
            </ButtonLink>
          </Popconfirm>
        </p>
      </div>
    </div>
  );
};

export default OptedIn;
